import React from 'react';
import PropTypes from 'prop-types';
import { FaGripLines } from 'react-icons/fa';

/** The grab bar under a resizable grid. Keyboard-operable via arrow keys. */
const ResizeHandle = ({ label, height, min, max, onPointerDown, onKeyDown }) => (
  <div
    role="separator"
    aria-orientation="horizontal"
    aria-valuemin={min}
    aria-valuemax={max}
    aria-valuenow={height}
    aria-label={label}
    tabIndex={0}
    onPointerDown={onPointerDown}
    onKeyDown={onKeyDown}
    className="tw-group tw-flex tw-h-2 tw-flex-shrink-0 tw-cursor-row-resize tw-touch-none tw-select-none tw-items-center tw-justify-center tw-border-x tw-border-b tw-border-slate-300 tw-bg-slate-100 hover:tw-border-primary-400 hover:tw-bg-primary-50 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-primary-300"
  >
    <FaGripLines className="tw-text-slate-400 group-hover:tw-text-primary-500" size={10} />
  </div>
);

ResizeHandle.propTypes = {
  label:          PropTypes.string.isRequired,
  height:         PropTypes.number.isRequired,
  min:            PropTypes.number.isRequired,
  max:            PropTypes.number.isRequired,
  onPointerDown:  PropTypes.func.isRequired,
  onKeyDown:      PropTypes.func.isRequired,
};

export default ResizeHandle;
